import { CONSTANTS } from "./constants";

const SSCER_CWNS_SCORES = [27.26, 40.38, 53.5, 66.62, 79.74, 92.86, 105.98, 119.1, 132.22, 145.34, 158.46, 171.58, 184.7];
const SSCSD_CWNS_SCORES = [38.97, 51.07, 63.17, 75.27, 87.37, 99.47, 111.57, 123.67, 135.77, 147.87];
const BCL_CWNS_SCORES = [0, 5.26, 10.11, 14.96, 19.81, 24.66, 29.51];
const CAT_CWNS_SCORES = [0.63, 3.96, 7.29, 10.62, 13.95, 17.28, 20.61, 23.94, 27.27];

export function compute(score, testId) {
  let values = null

  switch (testId) {
    case CONSTANTS.SSCERID:
      values = SSCER_CWNS_SCORES
      break;
    case CONSTANTS.SSCSDID:
      values = SSCSD_CWNS_SCORES
      break;
    case CONSTANTS.BCLID:
      values = BCL_CWNS_SCORES
      break;
    case CONSTANTS.CATID:
      values = CAT_CWNS_SCORES
      break;
    default:
      break;
  }

  const startPoint = testId === CONSTANTS.SSCERID ? (_, i) => i - 2 : (_, i) => i - 1
  const range = Array.from(
    { length: values.length },
    startPoint
  );

  return getCWNSRange(score, values, range);
}

export function getCWNSRange(score, values, range) {
  let lower = null;
  let upper = null;
  let direction = null;
  let description = `which is `;
  
  for (let i = 0; i < values.length - 1; i++) {
    if (score >= values[i] && score < values[i + 1]) {
      lower = range[i];
      upper = range[i + 1];
      break;
    }
  }
  if (score >= values[values.length - 1]) {
    lower = range[values.length - 1];
    direction = "above";
    description += `${lower} standard deviations above the mean for children and adolescents who do not stutter (CWNS).`;
    upper = null;
  }
  else if (score < values[0]) {
    lower = range[0];
    upper = range[1];
    direction = "below";
    description += `${upper} standard deviations below the mean for children and adolescents who do not stutter (CWNS).`;
  }
  else if (lower !== null && upper !== null) {
    direction = lower >= 0 ? "above" : "below";
    description += `between ${lower} and ${upper} standard deviations ${direction} the mean for children and adolescents who do not stutter (CWNS).`;
  }

  return { lower, upper, direction, description };
}